import React, { useEffect, useState, memo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
  Box,
  MenuItem,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import style from "../../../../styles/gri/general.module.css";
import { getRowErrorMessages } from "../../../../utils/getRowErrorMessage";
import {
  validateNumber,
  validatePercentage,
} from "../../../../utils/validateFields";
import DeleteRowDialog from "../../../../Components/Common/DeleteRowDialog";

const DynamicStaticTable = memo(
  ({
    inputData,
    subHeading,
    tables,
    setTables,
    total,
    setTotal,
    errors,
    setErrors,
    data,
    unit,
    defaultSegments,
    parameter,
    disabled,
    hide
  }) => {
    const [isFilleds, setIsFilled] = useState({});
    const [deleteDilog, setDeleteDialog] = useState(false);
    useEffect(() => {
      setTables(
        inputData?.map((section) => ({
          fieldName: section?.fieldName,
          rows:
            data?.[section?.fieldName]?.length > 0
              ? data[section?.fieldName]
              : defaultSegments.map((el) => ({ [parameter]: el })),
        }))
      );
    }, [data]);

    const [fieldToRemove, setFieldToRemove] = React.useState({
      tableIndex: null,
      rowIndex: null,
    });
    console.log(tables, "tablesValuesForColumns");
    const [openDialog, setOpenDialog] = React.useState(false);

    const handleAddRow = (tableIndex) => {
      setTables((prev) => {
        const newTables = [...prev];
        newTables[tableIndex].rows.push({});
        return newTables;
      });
    };

    const handleRemoveRow = (tableIndex, rowIndex) => {
      setDeleteDialog(false);
      setTables((prev) => {
        const newTables = [...prev];
        if (
          Object.values(newTables[tableIndex].rows[rowIndex]).some((val) => val)
        ) {
          setOpenDialog(true);
          setFieldToRemove({ tableIndex, rowIndex });
          return newTables;
        }

        newTables[tableIndex].rows.splice(rowIndex, 1);
        return newTables;
      });
    };

    const cancelRemoveRow = () => {
      setOpenDialog(false);
    };

    const confirmRemoveRow = () => {
      if (fieldToRemove) {
        const { tableIndex, rowIndex } = fieldToRemove;
        setTables((prev) => {
          const newTables = [...prev];
          newTables[tableIndex].rows.splice(rowIndex, 1);
          return newTables;
        });
      }
      setOpenDialog(false);
    };

    const handleInputChange = (
      tableIndex,
      rowIndex,
      fieldName,
      value,
      type,
      defaultValue
    ) => {
      console.log(value);
      // if (type === "percentage" && !validatePercentage(value)) return;
      //  if (type === "number" && !validateNumber(value)) return;
      if (type === "number" && !/^\d*$/.test(value)) return;
      // const updatedTables = [...tables];
      // updatedTables[tableIndex].rows[rowIndex][fieldName] = value;
      const updatedTables = tables.map((table) => ({
        ...table,
        rows: table.rows.map((row) => ({ ...row })),
      }));
      updatedTables[tableIndex].rows[rowIndex][fieldName] = value;

      // Update the specific field in the deep copy
      updatedTables[tableIndex].rows[rowIndex][fieldName] = value;
      const newTotals = updatedTables[tableIndex]?.rows?.reduce((acc, row) => {
        console.log(row);
        Object.keys(row).forEach((fieldName) => {
          console.log("row", row[fieldName]);
          console.log("row", row);

          // Skip 'ageGroup' field entirely
          if (type !== "number") return;

          // acc[fieldName] = (acc[fieldName] || 0) + Number(row[fieldName] || 0);
          acc[fieldName] = (acc[fieldName] || 0) + Number(row[fieldName] || 0);
        });
        return acc;
      }, {});

      console.log("total", newTotals);
      setTotal(newTotals?.quantity);

      const updatedErrors = { ...errors };
      if (updatedErrors[tableIndex] && updatedErrors[tableIndex][rowIndex]) {
        delete updatedErrors[tableIndex][rowIndex][fieldName];
        if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
          delete updatedErrors[tableIndex][rowIndex];
        }
        if (Object.keys(updatedErrors[tableIndex]).length === 0) {
          delete updatedErrors[tableIndex];
        }
      }

      setErrors(updatedErrors);
      setTables(updatedTables);
    };

    const checkIfAdded = () => {
      if (!Array.isArray(tables)) {
        console.warn("⚠️ tables is not an array!");
        return;
      }

      let newIsFilled = false; // Default state (assume tables are complete)

      tables.forEach((table, tableIndex) => {
        console.log(`🔍 Checking Table ${tableIndex}:`, table?.rows, table);

        if (typeof table !== "object" || table === null) {
          console.warn(`⚠️ Table ${tableIndex} is invalid!`);
          newIsFilled = true; // Mark as incomplete if it's not a valid object
          return;
        }

        // ✅ Ensure `table?.rows` is not empty
        if (!Array.isArray(table?.rows) || table.rows.length === 0) {
          console.warn(`⚠️ Table ${tableIndex} has no rows!`);
          newIsFilled = true;
          return;
        }

        // ✅ Check if each row has a valid `quantity`
        const hasInvalidRows = table.rows.some(
          (row) => !isFilled(row?.quantity)
        );
        const hasInvalidRowswaste = table.rows.some(
          (row) => !isFilled(row?.typeOfWaste)
        );
        if (hasInvalidRows) {
          console.warn(`⚠️ Table ${tableIndex} has rows with empty quantity!`);
          newIsFilled = true;
          return;
        }
        if (hasInvalidRowswaste) {
          console.warn(`⚠️ Table ${tableIndex} has rows with empty quantity!`);
          newIsFilled = true;
          return;
        }

        const flattenedTable = flattenObject(table);
        console.log(`📝 Flattened Table ${tableIndex}:`, flattenedTable);

        // ✅ Check if any required fields (excluding `measurementUnit`) are empty
        const hasEmptyFields = Object.entries(flattenedTable)
          .filter(([key]) => !key.startsWith("measurementUnit"))
          .some(([, value]) => !isFilled(value));

        console.log(
          `✅ Final Status for Table ${tableIndex}: ${
            hasEmptyFields ? "Incomplete" : "Complete"
          }`
        );

        if (hasEmptyFields) {
          newIsFilled = true; // Mark table as incomplete
        }
      });

      console.log("🛠️ Final Validation State:", newIsFilled);
      setIsFilled(newIsFilled);
    };

    // ✅ Run validation when `tables` or `inputData` change
    useEffect(() => {
      checkIfAdded();
    }, [tables, inputData]);

    const flattenObject = (obj, prefix = "") => {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        const newKey = prefix ? `${prefix}.${key}` : key;
        if (typeof value === "object" && value !== null) {
          Object.assign(acc, flattenObject(value, newKey)); // Recursively flatten nested objects
        } else {
          acc[newKey] = value;
        }
        return acc;
      }, {});
    };

    const isFilled = (value) => {
      return (
        value !== undefined &&
        value !== "" &&
        value !== null &&
        !(Array.isArray(value) && value.length === 0)
      );
    };

    return (
      <Box>
        <DeleteRowDialog
          {...{ openDialog, cancelRemoveRow, confirmRemoveRow }}
        />
        {/* {Heading && <p className={style.Heading}>{Heading}</p>} */}
        {subHeading && <p className={style.subHeading}>{subHeading}</p>}
        {inputData?.map((section, tableIndex) => (
          <div key={section.fieldName} sx={{ marginBottom: "1rem" }}>
            <Box sx={{ display: "flex", gap: 1 }}>
              {section?.letter && (
                <p className={style.ques_heading}>{section.letter}</p>
              )}
              <p className={style.ques_heading}>{section.title}</p>
            </Box>

            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "10px",
                ml: 2,
                width: "98%",
              }}
            >
              <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                <TableHead>
                  <TableRow
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#1C486B",
                      border: "1px solid #ddd",
                    }}
                  >
                    <TableCell
                      sx={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "10%",
                        textAlign: "center",
                      }}
                    >
                      S. No.
                    </TableCell>
                    {section?.fields?.map((field) => (
                      <TableCell
                        key={field?.fieldName}
                        style={{
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          width: field.width,
                        }}
                      >
                        {field?.title}
                      </TableCell>
                    ))}
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "5%",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tables[tableIndex]?.rows?.map((row, rowIndex) => {
                    console.log(row, "checking row");
                    return (
                      <TableRow
                        key={rowIndex}
                        sx={{
                          "& > th": {
                            color: "white",
                            fontWeight: "bold",
                            py: "0.5rem",
                            px: "0.5rem",
                            border: "1px solid rgba(224, 224, 224, 1)",
                            height: "30px",
                          },
                        }}
                      >
                        <TableCell sx={{ textAlign: "center", width: "10%" }}>
                          {rowIndex + 1} .
                        </TableCell>
                        {section?.fields?.map((field) => (
                          <TableCell
                            key={field?.fieldName}
                            sx={{
                              border: "1px solid #DBDBDB",
                              py: "0.5rem",
                              color: field.fieldName === parameter && "#1C486B",
                              width: field.width,
                            }}
                          >
                            {field.fieldName === parameter &&
                            rowIndex < defaultSegments?.length ? (
                              <span>{row[field.fieldName]}</span> // Display the value as plain text if the condition is true
                            ) : field?.type === "select" ? (
                              <Select
                                disabled={
                                  disabled ||
                                  (rowIndex < defaultSegments?.length &&
                                    field.fieldName === parameter)
                                }
                                multiple={field?.multiselect}
                                value={
                                  field?.multiselect
                                    ? row[field?.fieldName] || [] // Ensure value is an array for multiselect
                                    : row[field?.fieldName] || "" // Ensure value is a string for single select
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type
                                  )
                                }
                                displayEmpty
                                fullWidth
                                size="small"
                                sx={{
                                  border: "none",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: "none",
                                    },
                                }}
                                renderValue={(selected) =>
                                  field.multiselect
                                    ? selected.length > 0
                                      ? selected.join(", ")
                                      : field.placeholder || "Select"
                                    : selected || field.placeholder || "Select"
                                }
                              >
                                <MenuItem value={""} disabled>
                                  {field.placeholder || "Select"}
                                </MenuItem>
                                {field.options?.map((option, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={option?.name || option} // Ensure the `value` matches the `row[field.fieldName]`
                                  >
                                    {field.multiselect ? (
                                      <>
                                        <Checkbox
                                          checked={
                                            row[field.fieldName]?.includes(
                                              option?.name || option
                                            ) || false
                                          } // Check if the option is selected
                                          size="small"
                                          disabled={disabled}
                                        />
                                        {option?.name || option}
                                      </>
                                    ) : (
                                      option?.name || option
                                    )}
                                  </MenuItem>
                                ))}
                              </Select>
                            ) : field.type === "radio" ? (
                              // console.log(row,row[field.fieldName],"Checking...")
                              <Box sx={{ display: "flex" }}>
                                <FormControl sx={{ my: 1, display: "flex" }}>
                                  <RadioGroup
                                    row
                                    disabled={
                                      disabled ||
                                      (rowIndex <= defaultSegments?.length &&
                                        field.fieldName === parameter)
                                    }
                                    value={row[field.fieldName] || "Yes"}
                                    onChange={(e) =>
                                      handleInputChange(
                                        tableIndex,
                                        rowIndex,
                                        field.fieldName,
                                        e.target.value,
                                        field.type
                                      )
                                    }
                                  >
                                    <FormControlLabel
                                      value="Yes"
                                      control={<Radio disabled={disabled} />}
                                      label="Yes"
                                    />
                                    <FormControlLabel
                                      value="No"
                                      control={<Radio disabled={disabled} />}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </Box>
                            ) : (
                              <TextField
                                disabled={
                                  field?.fieldName === "unit"
                                    ? true
                                    : false || disabled
                                }
                                placeholder={field.placeholder}
                                type={field.type}
                                value={
                                  field?.fieldName === "unit"
                                    ? field?.value
                                    : row[field.fieldName] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type,
                                    field?.value
                                  )
                                }
                                multiline
                                rows={1}
                                sx={{
                                  color: "#1C486B",
                                  width: "100%",
                                  py: "0.5rem",
                                  "& .MuiInputBase-root": {
                                    overflowY: "auto",
                                    cursor: "default",
                                  },
                                  "& .MuiInputBase-root:hover": {
                                    cursor: "pointer",
                                  },
                                }}
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                  sx: {
                                    color:
                                      field.fieldName === parameter &&
                                      "#1C486B",
                                    "&.Mui-disabled": {
                                      color: "red", // Ensure font color change works for disabled state
                                    },
                                  },
                                }}
                              />
                            )}
                          </TableCell>
                        ))}

                        <TableCell sx={{ width: "5%" }}>
                          {/* <Dialog open={deleteDilog} onClose={() => setDeleteDialog(false)}>
                        <DialogTitle>Confirm Delete</DialogTitle>
                        <DialogContent>
                          <DialogContentText>
                            Do you really want to delete this entry?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={() => setDeleteDialog(false)} color="primary">
                            Cancel
                          </Button>
                          <Button 
                          // onClick={handleDeleteAggree}
                          onClick={() => handleRemoveRow(tableIndex, rowIndex)}
                          color="secondary">
                            Confirm
                          </Button>
                        </DialogActions>
                      </Dialog> */}
                          <IconButton
                            disabled={
                              rowIndex < defaultSegments?.length || disabled
                            }
                            onClick={() =>
                              handleRemoveRow(tableIndex, rowIndex)
                            }
                            color="error"
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow sx={{ ml: 1, backgroundColor: "#DBDBDB" }}>
                    <TableCell></TableCell>
                    <TableCell>Total</TableCell>
                    {/* <TableCell>{unit}</TableCell> */}
                    <TableCell
                      // key={el?.fieldName}
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        padding: "12px 12px",
                      }}
                    >
                      {total}
                      {/* {displayValue} */}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ mt: 1, ml: 3 }}>
              {Object.keys(errors).length > 0 &&
                getRowErrorMessages(tableIndex, inputData, tables, errors).map(
                  (errorMessage, idx) => (
                    <p
                      key={idx}
                      color="error"
                      variant="caption"
                      style={{
                        lineHeight: "1.2",
                        margin: "2px 0",
                        color: "#d34040",
                        fontSize: "10px",
                        fontStyle: "italic",
                      }}
                    >
                      {errorMessage}
                    </p>
                  )
                )}
            </Box>
            {/* Add row button */}
            {!hide &&
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                endIcon={<Add />}
                disabled={isFilleds || false || disabled}
                onClick={() => handleAddRow(tableIndex)}
                sx={{
                  // marginTop: "1rem",
                  color: "#1C486B",
                  width: "7rem",
                  borderColor: "#1C486B",
                }}
                variant="outlined"
              >
                Add
              </Button>
            </Box>
  }

            {/* Dynamic error messages for missing fields */}
          </div>
        ))}
      </Box>
    );
  }
);

export default DynamicStaticTable;
